// Print BOGHMA Brand Signature
const svgString = `
<svg xmlns="http://www.w3.org/2000/svg" width="600" height="180">
  <style>
    .big-text {
      font-family: 'Arial Black', sans-serif; 
      font-size: 80px; 
      font-weight: 900; 
      text-anchor: middle; 
    }

    .bg { fill: #000; }
    .title { fill: #fff; }
    .shadow { fill: #FFBF00; }
    
    .subtitle { 
      fill: #FFBF00; 
      font-family: sans-serif; 
      font-size: 18px; 
      font-weight: bold; 
      text-anchor: middle; 
      letter-spacing: 2px;
    }

    .signature { 
      fill: rgba(255, 255, 255, 0.5); 
      font-family: sans-serif; 
      font-size: 12px; 
      font-style: italic; 
      text-anchor: middle; 
      letter-spacing: 1px;
    }
  </style>
  
  <rect class="bg" width="100%" height="100%" rx="15" ry="15" />
  
  <text class="shadow big-text" x="304" y="99">BOGHMA</text>
  
  <text class="title big-text" x="300" y="95">BOGHMA</text>
  
  <text class="subtitle" x="300" y="125">Supercharge Your 3D Pipeline</text>
  
  <text class="signature" x="300" y="150">Designed by Kiecooboi</text>
</svg>
`

const base64String = btoa(decodeURIComponent(encodeURIComponent(svgString)))
const svgUrl = `data:image/svg+xml;base64,${base64String}`

console.log(
  "%c ",
  `
  padding: 90px 300px; 
  background-image: url('${svgUrl}'); 
  background-size: contain; 
  background-repeat: no-repeat; 
  line-height: 0; 
  font-size: 1px;
  `,
)

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
